// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"XO-z","carouselContainer":"YO-z"};